export default {
  mobile: /^[7-9]\d{9}$/,
  landline: /^[0]\d{10}$/,
  pan_no: /^[A-Z]{5}\d{4}[A-Z]$/,
  pincode: /^\d{6}$/,
  aadhaar_no: /^\d{12}$/,
  float: /^\d+(\.\d+)?$/,
  stringWithSpecialChars: /^[a-zA-Z\d][a-zA-Z\d-_.,"'() ]*[a-zA-Z\d.]$/,
  dateString: /^\d{4}-\d{2}-\d{2}$/,
};



// WEBPACK FOOTER //
// ./src/utils/validationRegex.js